import React from 'react';
import { IonSpinner } from '@ionic/react';

interface CenteredLoaderProps {
  message?: string;
}

const CenteredLoader: React.FC<CenteredLoaderProps> = ({ message }) => {
  return (
    <div className="flex items-center justify-center h-full min-h-screen centered-loader">
      <div className="flex flex-col items-center space-y-4">
        <IonSpinner name="crescent" className="w-12 h-12" color="primary" />
        {message && (
          <p className="text-gray-600 dark:text-gray-400 text-center px-4">{message}</p>
        )}
      </div>
    </div>
  );
};

export default CenteredLoader;